import React, { useState } from 'react';
import styles from './banner.module.css';

const Banner = ({ bannerImage, showButton, showMouseMove, mouseImage }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (event) => {
    const { clientX, clientY } = event;
    const mouseX = (clientX / window.innerWidth) * 2 - 1;
    const mouseY = -(clientY / window.innerHeight) * 2 + 1;
    setPosition({ x: mouseX, y: mouseY });
  };

  return (
    <div className={styles.container}>
      <div className={styles.banner} onMouseMove={handleMouseMove} style={{ backgroundImage: `url(${bannerImage})` }}>
        {showMouseMove && (
          <div className={styles.mouseMove} style={{ transform: `translate(-50%, -50%) translateX(calc(-50% + ${position.x * 50}px)) translateY(calc(-50% + ${position.y * 50}px))` }}>
            <img src={mouseImage} alt="Mouse" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Banner;